import React, { Component } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'lodash/fp/compose';
import { Select } from 'antd';

import API from '../../../api';
import SaleProcess from '../../../components/clients/sale-process';
import { promiseLoader } from '../../../components/common/promise-loader';

const { Option } = Select;

class BuyersClientShow extends Component {
  static propTypes = {
    client: object
  };

  constructor (props) {
    super(props);
    const { client } = props;
    const saleProcesses = client.saleProcesses || [];
    this.state = {
      selectedIndex: 0,
      saleProcesses
    };
  }

  render () {
    const { selectedIndex, saleProcesses } = this.state;

    if (!saleProcesses.length) {
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <h2>No hay propiedades asignadas</h2>
        </div>
      );
    }

    const selectedSP = saleProcesses[selectedIndex];

    return (
      <div>
        {saleProcesses.length > 1 && (
          <div style={{
            padding: '16px 24px',
            background: '#fafafa',
            borderBottom: '1px solid #f0f0f0'
          }}>
            <label style={{ marginRight: 8, fontWeight: 600 }}>
              Propiedad:
            </label>
            <Select
              value={selectedIndex}
              onChange={(value) => this.setState({ selectedIndex: value })}
              style={{ minWidth: 300 }}
            >
              {saleProcesses.map((sp, idx) => (
                <Option key={idx} value={idx}>
                  {sp.name || `Propiedad ${idx + 1}`}
                </Option>
              ))}
            </Select>
          </div>
        )}
        <SaleProcess saleProcess={selectedSP} />
      </div>
    );
  }
}

export default compose(
  withRouter,
  promiseLoader(
    ({ match: { params: { id } } }) => API.buyers.getClient(id),
    'client',
    true
  )
)(BuyersClientShow);
